/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CollaboType from './CollaboType';
import NftBoxGrade from './NftBoxGrade';
import NftBoxType from './NftBoxType';
import NftGenerateType from './NftGenerateType';
import NftGrade from './NftGrade';
import NftSeal from './NftSeal';
import NftType from './NftType';

/**
 * The NftGenerateModel model module.
 * @module model/NftGenerateModel
 * @version 1.0
 */
class NftGenerateModel {
    /**
     * Constructs a new <code>NftGenerateModel</code>.
     * @alias module:model/NftGenerateModel
     */
    constructor() { 
        
        NftGenerateModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGenerateModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGenerateModel} obj Optional instance to populate.
     * @return {module:model/NftGenerateModel} The populated <code>NftGenerateModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGenerateModel();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftGenerateType')) {
                obj['nftGenerateType'] = NftGenerateType.constructFromObject(data['nftGenerateType']);
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = NftType.constructFromObject(data['nftType']);
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = NftGrade.constructFromObject(data['nftGrade']);
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = NftSeal.constructFromObject(data['nftSeal']);
            }
            if (data.hasOwnProperty('collabo')) {
                obj['collabo'] = CollaboType.constructFromObject(data['collabo']);
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('isReveal')) {
                obj['isReveal'] = ApiClient.convertToType(data['isReveal'], 'Boolean');
            }
            if (data.hasOwnProperty('revealableAt')) {
                obj['revealableAt'] = ApiClient.convertToType(data['revealableAt'], 'Date');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = NftBoxType.constructFromObject(data['boxType']);
            }
            if (data.hasOwnProperty('boxGrade')) {
                obj['boxGrade'] = NftBoxGrade.constructFromObject(data['boxGrade']);
            }
            if (data.hasOwnProperty('boxBlessed')) {
                obj['boxBlessed'] = ApiClient.convertToType(data['boxBlessed'], 'Boolean');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
            if (data.hasOwnProperty('engineCount')) {
                obj['engineCount'] = ApiClient.convertToType(data['engineCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGenerateModel</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGenerateModel</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
NftGenerateModel.prototype['nftUid'] = undefined;

/**
 * @member {module:model/NftGenerateType} nftGenerateType
 */
NftGenerateModel.prototype['nftGenerateType'] = undefined;

/**
 * @member {module:model/NftType} nftType
 */
NftGenerateModel.prototype['nftType'] = undefined;

/**
 * @member {module:model/NftGrade} nftGrade
 */
NftGenerateModel.prototype['nftGrade'] = undefined;

/**
 * @member {module:model/NftSeal} nftSeal
 */
NftGenerateModel.prototype['nftSeal'] = undefined;

/**
 * @member {module:model/CollaboType} collabo
 */
NftGenerateModel.prototype['collabo'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
NftGenerateModel.prototype['plusFlag'] = undefined;

/**
 * @member {Boolean} isReveal
 */
NftGenerateModel.prototype['isReveal'] = undefined;

/**
 * @member {Date} revealableAt
 */
NftGenerateModel.prototype['revealableAt'] = undefined;

/**
 * @member {module:model/NftBoxType} boxType
 */
NftGenerateModel.prototype['boxType'] = undefined;

/**
 * @member {module:model/NftBoxGrade} boxGrade
 */
NftGenerateModel.prototype['boxGrade'] = undefined;

/**
 * @member {Boolean} boxBlessed
 */
NftGenerateModel.prototype['boxBlessed'] = undefined;

/**
 * @member {Number} count
 */
NftGenerateModel.prototype['count'] = undefined;

/**
 * @member {Number} engineCount
 */
NftGenerateModel.prototype['engineCount'] = undefined;






export default NftGenerateModel;

